<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title d-flex align-items-center gap-2">
        <ng-container *ngIf="rental">
          <app-rental-image [rental]="rental" [size]="35"></app-rental-image>
          {{ rental.name }}
        </ng-container>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom" role="tablist">
      <li [class.active]="tab === tabs.Calendar">
        <a
          (click)="tab = tabs.Calendar"
          i18n-matTooltip
          matTooltip="A Standard Calendar showing rates for all rate categories."
          matTooltipPosition="below"
        >
          <ng-container i18n>Rates Calendar</ng-container>
        </a>
      </li>
      <li [class.active]="tab === tabs.Rates">
        <a
          (click)="tab = tabs.Rates"
          i18n-matTooltip
          matTooltip="All rates and rate periods shown in tabular format."
          matTooltipPosition="below"
        >
          <ng-container i18n>Rates Table</ng-container>
        </a>
      </li>
      <li [class.active]="tab === tabs.RateMappings">
        <a
          (click)="tab = tabs.RateMappings"
          i18n-matTooltip
          matTooltip="Rate Maps allow you to streamline the pushing of rates to connected channels. Once you have created your rate maps you may then update all connected channels by clicking the Push Rates button at right. Rate Maps are also used to automatically update channel rates if you use Dynamic Rates. You must, however, enable auto sync for the rates to be automatically updated."
          matTooltipPosition="below"
        >
          <ng-container i18n>Rate Mappings</ng-container>
        </a>
      </li>
      <li *ngIf="showDiscounts" [class.active]="tab === tabs.Discounts">
        <a
          (click)="tab = tabs.Discounts"
          i18n-matTooltip
          matTooltip="All discounts for this rental"
          matTooltipPosition="below"
        >
          <ng-container i18n>Discounts</ng-container>
        </a>
      </li>
      <li [class.active]="tab === tabs.Settings">
        <a (click)="tab = tabs.Settings" [matTooltip]="baseRateTooltip" matTooltipPosition="below">
          <ng-container i18n>Settings</ng-container>
          <i *ngIf="hasIncompleteBaseRate" class="fal fa-exclamation-triangle text-danger"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <div *ngIf="rental" class="tab-content">
        <app-rental-rates-calendar *ngIf="tab === tabs.Calendar" [rental]="rental" [loading]="!initialized">
        </app-rental-rates-calendar>

        <app-rates-table *ngIf="tab === tabs.Rates" [rental]="rental"> </app-rates-table>

        <app-rental-rate-mappings-table *ngIf="tab === tabs.RateMappings" [defaultRental]="rental">
        </app-rental-rate-mappings-table>

        <app-discounts-table *ngIf="tab === tabs.Discounts" [showAddBtn]="true" [rental]="rental">
        </app-discounts-table>

        <app-rental-rate-settings *ngIf="tab === tabs.Settings" [rental]="rental"> </app-rental-rate-settings>
      </div>
    </div>
  </div>
</div>
